module.exports = __webpack_public_path__ + "img/roles.98616a2e.svg";